import { faArrowUpRight } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { PropsWithChildren } from 'react';
import { twMerge } from 'tailwind-merge';

import { PropsWithClasses } from '@lamesarv-sdk/types';

export interface ICustomLinkProps extends PropsWithClasses, PropsWithChildren {
  href: string;
  title?: string;
  external?: boolean;
}

const CustomLink = (props: ICustomLinkProps) => {
  return (
    <a
      href={props.href}
      className={twMerge(
        'font-semibold text-blue-700 hover:text-red-800 underline underline-offset-4 decoration-dashed',
        props.className,
      )}
      target="_blank"
    >
      {props.children}
      {!props.children && (
        <div className="flex flex-row gap-1 items-center">
          {!props.children && props.title && <span>{props.title}</span>}
          {props.external && <FontAwesomeIcon icon={faArrowUpRight} className="w-4 h-4" />}
        </div>
      )}
    </a>
  );
};

export const customRemarkComponents = {
  p: ({ children }) => <p className="text-textBase mb-2 leading-relaxed">{children}</p>,
  strong: ({ children }) => <strong className="font-bold text-black">{children}</strong>,
  a: ({ children, href, target }) => {
    let _href = href || '#';

    _href = _href.replace('xmpp:', 'tel:');

    return (
      <CustomLink href={_href} external={(target as string)?.toLowerCase()?.trim() === '_blank'}>
        {children}
      </CustomLink>
    );
  },
  ul: ({ children }) => <ul className="text-textBase leading-8 gap-4 ml-4 pl-4 mb-5 last:mb-5">{children}</ul>,
  li: ({ children }) => <li className="list-disc">{children}</li>,
  ol: ({ children }) => <li className="list-decimal leading-8 gap-4 ml-4 pl-4 mb-5 last:mb-5">{children}</li>,
};
